module.exports = __webpack_public_path__ + "img/medal.a88473de.png";